import { Id } from "./id";

type AllOrganizationalUnitsFilter = {
  name: string;
  excludedUuid?: Id;
  page: number;
  size: number;
};

const allOrganizationalUnitsFilter: AllOrganizationalUnitsFilter = {
  name: "",
  page: 0,
  size: 20,
};

export type { AllOrganizationalUnitsFilter };

export { allOrganizationalUnitsFilter };
